import { useCallback } from 'react';

import { SellerService } from '@/api';

import { CNAME_MAX_AVAILABILITY_ATTEMPTS } from '../OnboardingForm.constants';
import { buildCNameCandidate } from '../OnboardingForm.helpers';

export interface ResolvedCName {
  cName: string;
  domainName: string;
}

export function useFindAvailableCName(): (
  slug: string,
) => Promise<ResolvedCName | undefined> {
  return useCallback(
    async (slug: string): Promise<ResolvedCName | undefined> => {
      for (
        let attempt = 0;
        attempt < CNAME_MAX_AVAILABILITY_ATTEMPTS;
        attempt += 1
      ) {
        const cName = buildCNameCandidate({ slug, attempt });
        const response = await SellerService.getDomainNameFromCNameQuery({
          cName,
        });

        if (response.failure) {
          return undefined;
        }

        if (response.value.available) {
          return { cName, domainName: response.value.domainName };
        }
      }

      return undefined;
    },
    [],
  );
}
